<template>
    <div>
        <v-app-bar 
            elevation=1
            fixed
        >   
            <v-toolbar-title>
                <router-link :to="{ name: 'dashboard'}"><img
                        src="/img/logo-header.png"
                        class="logo"
                    />
                </router-link>
            </v-toolbar-title>
            <v-divider
                class="mx-4"
                vertical
            ></v-divider>
            <h1 v-if="env!='prod'" style="color: red;">STAGE</h1>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-tabs>
                    <v-tab class="pa-0 ma-0" style="min-width:0px" :to="{ name:'admin'}"/>
                    <v-tab class="pa-0 ma-0" style="min-width:0px" :to="{ name:'dashboard'}"/> 
                    <v-tab v-if="slidesModule":to="{ name: 'slides'}">Slides</v-tab>               
                    <v-tab v-if="modelsModule" :to="{ name: 'debtModel'}">Models</v-tab>
                    <v-tab v-if="systematicEconomicsModule" :to="{ name: 'systematicEconomics'}">Systematic-Economics </v-tab>
                </v-tabs>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-menu 
            bottom left
            :close-on-click="false"
            :close-on-content-click="true"
            :offset-y="true">
                <template v-slot:activator="{ on }">
                    <v-btn
                        class="btnProfile"
                        dark               
                        icon
                        v-on="on"
                    >
                        <v-icon>{{ icons.mdiAccount }}</v-icon>
                    </v-btn>                    
                </template>
                <v-card>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>                       
                                <v-list-item-title>{{ firstName_lastName }}</v-list-item-title>
                                <v-list-item-subtitle>{{email}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-list v-if="permissionProfileEdit">
                        <v-list-item>
                            <v-list-item-content>                       
                                <v-list-item-title>Password</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn text small color="primary" :to="{name : 'reset-my-password'}">Reset</v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                    <v-divider v-if="permissionModule"></v-divider>
                    <v-list v-if="permissionModule">
                        <v-list-item>
                            <v-list-item-content>                       
                                <v-list-item-title>Admin</v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn text small color="primary" :to="{name : 'admin'}">Admin Control Panel</v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list>
                        <v-list-item>
                            <v-list-item-action>
                                <v-btn text small color="primary" @click="logout">Logout</v-btn>
                            </v-list-item-action>
                            <v-spacer></v-spacer>
                            <v-list-item-action>
                                <v-btn text small color="primary">Close</v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>
        </v-app-bar>
    </div>     
  </template>
    
<script>
    import { mdiAccount} from '@mdi/js'
    import storageUtil from '@/helpers/storage'
    import mixinPermissions from '@/mixins/permissions'
    import appConfig from '@/config/appConfig'
    export default {
        data () {
            return {
                icons: {
                    mdiAccount
                },
                env:appConfig.env
            }   
        },
        mixins: [mixinPermissions],
        computed: {
            user () {
                return this.$store.getters.getUser
            },
            firstName_lastName () {
                return this.user!=null?this.user.lastname + ', ' + this.user.firstname:""
            },
            email () {
                return this.user!=null?this.user.email:""
            },
            systematicEconomicsModule(){
                return this.haveModulePermission('systematicEconomics')
            },
            modelsModule(){
                return this.haveModulePermission('models')
            },
            slidesModule(){
                return this.haveModulePermission('slides')
            },
            permissionModule(){
                return this.haveModulePermission('admin')
            },
            permissionProfileEdit(){
                return this.havePermission('general_profile:edit')
            }
        },
        methods: {
            logout () {
                this.$store.dispatch('logout', this.$router)
            },
            myProfile () {
                this.$router.push({ name: 'my-profile' })
            }
       }
    }
  </script>
  <style scoped>
    .v-btn{
        text-transform: none !important;
    }
    .btnProfile{
        background-color: rgb(42, 42, 180) !important;
    }
    .v-list-item__title {
        font-size: small !important;
    }
    .v-list-item__subtitle{
        font-size: small !important;
    }
    .v-list-item {
        align-items: center;
        display: flex;
        flex: 1 1 100%;
        letter-spacing: normal;
        min-height: 20px;
        outline: none;
        padding: 0 16px;
        position: relative;
        text-decoration: none;
    }
    .theme--light.v-app-bar.v-toolbar.v-sheet {
        background-color:white !important;
    }
  </style>